import Link from "next/link";
import RightArrowIcon from "../icons/RightArrowIcon";

const VoteNowButton = ({ link }) => {
  return <>
    <Link
      href={link}
      className="inline-flex justify-center items-center pt-6 pb-6 space-x-2 text-sm text-red-400 hover:text-red-600 dark:text-green-400 dark:hover:text-green-600">

      <span>Vote now</span>
      <RightArrowIcon />

    </Link>
  </>;
};

export default VoteNowButton;
